/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchCompanies200ResponseInner
 */
export interface SearchCompanies200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof SearchCompanies200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCompanies200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCompanies200ResponseInner
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCompanies200ResponseInner
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCompanies200ResponseInner
     */
    entityType?: string;
}

/**
 * Check if a given object implements the SearchCompanies200ResponseInner interface.
 */
export function instanceOfSearchCompanies200ResponseInner(value: object): value is SearchCompanies200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    return true;
}

export function SearchCompanies200ResponseInnerFromJSON(json: any): SearchCompanies200ResponseInner {
    return SearchCompanies200ResponseInnerFromJSONTyped(json, false);
}

export function SearchCompanies200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCompanies200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'taxId': json['taxId'],
        'address': json['address'] == null ? undefined : json['address'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function SearchCompanies200ResponseInnerToJSON(json: any): SearchCompanies200ResponseInner {
    return SearchCompanies200ResponseInnerToJSONTyped(json, false);
}

export function SearchCompanies200ResponseInnerToJSONTyped(value?: SearchCompanies200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'taxId': value['taxId'],
        'address': value['address'],
        'entityType': value['entityType'],
    };
}

